import React from 'react';
import { FaShieldAlt, FaCheckCircle, FaArrowRight, FaRocket } from 'react-icons/fa';
import {
    SiReact, SiNodedotjs, SiMongodb, SiFigma, SiWordpress, SiFlutter,
    SiPython, SiJavascript, SiFirebase, SiGit, SiDocker, SiTailwindcss
} from 'react-icons/si';


const TrustCertifications = () => {
    const techStack = [
        { icon: <SiReact />, name: 'React' },
        { icon: <SiNodedotjs />, name: 'Node.js' },
        { icon: <SiMongodb />, name: 'MongoDB' },
        { icon: <SiFigma />, name: 'Figma' },
        { icon: <SiWordpress />, name: 'WordPress' },
        { icon: <SiFlutter />, name: 'Flutter' },
        { icon: <SiPython />, name: 'Python' },
        { icon: <SiJavascript />, name: 'JavaScript' },
        { icon: <SiFirebase />, name: 'Firebase' },
        { icon: <SiGit />, name: 'Git' },
        { icon: <SiDocker />, name: 'Docker' },
        { icon: <SiTailwindcss />, name: 'Tailwind CSS' },
    ];

    const trustBadges = [
        '7-Day Money-Back Guarantee',
        'Industry-Standard Workflows',
        'NDA-Protected Projects',
        'Dedicated Support',
    ];

    return (
        <>
            <section className="trust-certs-section">
                <div className="trust-certs-glow-1"></div>
                <div className="trust-certs-glow-2"></div>

                <div className="container trust-certs-inner">
                    {/* Section Header */}
                    <div className="text-center mb-5" data-aos="fade-up">
                        <span className="trust-certs-badge">TRUST & CREDIBILITY</span>
                        <h2 className="trust-certs-heading">
                            Built on <span className="trust-certs-gradient">Transparency & Trust</span>
                        </h2>
                        <p className="trust-certs-subheading mx-auto">
                            We believe trust isn't claimed — it's earned. Here's how we back up every promise.
                        </p>
                    </div>

                    {/* Row 1: Two Premium Cards */}
                    <div className="row g-4 mb-5" data-aos="fade-up" data-aos-delay="100">
                        <div className="col-md-6">
                            <div className="trust-premium-card">
                                <div className="trust-card-shimmer"></div>
                                <div className="trust-card-icon-wrap trust-card-icon-purple">
                                    <FaShieldAlt />
                                </div>
                                <h3 className="trust-card-title">Government Registered & State Licensed</h3>
                                <p className="trust-card-text">
                                    Octalbees holds valid registrations under <strong>Central Government (Udyam/MSME)</strong> and is licensed as a 
                                    <strong> recognized commercial establishment</strong> by the State Government. We operate under full legal compliance at both national and state levels.
                                </p>
                                <div className="trust-card-footer">
                                    <span className="trust-verified-badge">
                                        <FaCheckCircle /> Central & State Govt. Verified
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="trust-premium-card">
                                <div className="trust-card-shimmer"></div>
                                <div className="trust-card-icon-wrap trust-card-icon-amber">
                                    <FaRocket />
                                </div>
                                <h3 className="trust-card-title">Agile & Transparent Delivery</h3>
                                <p className="trust-card-text">
                                    We believe in complete transparency. Our <strong>agile project management</strong> approach ensures you are involved at every milestone, with clear timelines, regular updates, and measurable results.
                                </p>
                                <div className="trust-card-footer">
                                    <span className="trust-verify-link">
                                        Client-First Approach <FaArrowRight />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Row 2: Technology Marquee */}
                    <div className="tech-marquee-section" data-aos="fade-up" data-aos-delay="200">
                        <p className="tech-marquee-label">TECHNOLOGIES WE WORK WITH</p>
                        <div className="tech-marquee-wrapper">
                            <div className="tech-marquee-fade tech-marquee-fade-left"></div>
                            <div className="tech-marquee-fade tech-marquee-fade-right"></div>
                            <div className="tech-marquee-track">
                                {/* Duplicate the list for seamless infinite scroll */}
                                {[...techStack, ...techStack].map((tech, index) => (
                                    <div className="tech-marquee-item" key={index}>
                                        <span className="tech-marquee-icon">{tech.icon}</span>
                                        <span className="tech-marquee-name">{tech.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Row 3: Trust Badges Strip */}
                    <div className="trust-badges-strip" data-aos="fade-up" data-aos-delay="300">
                        {trustBadges.map((badge, index) => (
                            <div className="trust-strip-item" key={index}>
                                <FaCheckCircle className="trust-strip-check" />
                                <span>{badge}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <style>{`
                /* =============================================
                   TRUST & CERTIFICATIONS SECTION
                   ============================================= */

                .trust-certs-section {
                    padding: 100px 0;
                    background-color: #0c001f;
                    color: #fff;
                    position: relative;
                    overflow: hidden;
                }

                .trust-certs-inner {
                    position: relative;
                    z-index: 2;
                }

                .trust-certs-glow-1 {
                    position: absolute;
                    width: 500px;
                    height: 500px;
                    background: radial-gradient(circle, rgba(160, 79, 244, 0.12) 0%, transparent 70%);
                    border-radius: 50%;
                    top: -10%;
                    right: -10%;
                    pointer-events: none;
                }

                .trust-certs-glow-2 {
                    position: absolute;
                    width: 400px;
                    height: 400px;
                    background: radial-gradient(circle, rgba(255, 180, 40, 0.08) 0%, transparent 70%);
                    border-radius: 50%;
                    bottom: -15%;
                    left: -10%;
                    pointer-events: none;
                }

                /* Section Header */
                .trust-certs-badge {
                    display: inline-block;
                    font-size: 0.75rem;
                    font-weight: 700;
                    letter-spacing: 3px;
                    color: #ffb428;
                    background: rgba(255, 180, 40, 0.08);
                    padding: 7px 20px;
                    border-radius: 50px;
                    border: 1px solid rgba(255, 180, 40, 0.2);
                    margin-bottom: 20px;
                    text-transform: uppercase;
                }

                .trust-certs-heading {
                    font-size: 3rem;
                    font-weight: 800;
                    color: #fff;
                    letter-spacing: -1px;
                    margin-bottom: 1rem;
                }

                .trust-certs-gradient {
                    background: linear-gradient(90deg, #ffb428, #a04ff4);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .trust-certs-subheading {
                    font-size: 1.1rem;
                    color: #8a8a8a;
                    max-width: 600px;
                    line-height: 1.7;
                    text-align: center;
                }

                /* ─── Premium Trust Cards ─── */
                .trust-premium-card {
                    background: rgba(255, 255, 255, 0.025);
                    border: 1px solid rgba(255, 255, 255, 0.06);
                    border-radius: 20px;
                    padding: 40px 32px;
                    height: 100%;
                    position: relative;
                    overflow: hidden;
                    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                    backdrop-filter: blur(8px);
                }

                .trust-premium-card:hover {
                    transform: translateY(-6px);
                    border-color: rgba(160, 79, 244, 0.3);
                    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
                }

                /* Shimmer effect */
                .trust-card-shimmer {
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.03), transparent);
                    transition: none;
                }

                .trust-premium-card:hover .trust-card-shimmer {
                    animation: cardShimmer 1.5s ease;
                }

                @keyframes cardShimmer {
                    0% { left: -100%; }
                    100% { left: 100%; }
                }

                /* Icon */
                .trust-card-icon-wrap {
                    width: 60px;
                    height: 60px;
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.6rem;
                    margin-bottom: 24px;
                    transition: all 0.3s ease;
                }

                .trust-card-icon-purple {
                    background: rgba(160, 79, 244, 0.1);
                    color: #a04ff4;
                    border: 1px solid rgba(160, 79, 244, 0.2);
                }

                .trust-premium-card:hover .trust-card-icon-purple {
                    background: #a04ff4;
                    color: #fff;
                    box-shadow: 0 8px 20px rgba(160, 79, 244, 0.35);
                }

                .trust-card-icon-amber {
                    background: rgba(255, 180, 40, 0.1);
                    color: #ffb428;
                    border: 1px solid rgba(255, 180, 40, 0.2);
                }

                .trust-premium-card:hover .trust-card-icon-amber {
                    background: #ffb428;
                    color: #0c001f;
                    box-shadow: 0 8px 20px rgba(255, 180, 40, 0.35);
                }

                .trust-card-title {
                    font-size: 1.4rem;
                    font-weight: 700;
                    color: #fff;
                    margin-bottom: 14px;
                }

                .trust-card-text {
                    font-size: 1rem;
                    color: #a0a0a0;
                    line-height: 1.75;
                    margin-bottom: 20px;
                    text-align: left;
                }

                .trust-card-text strong {
                    color: #d0d0d0;
                }

                .trust-card-footer {
                    padding-top: 16px;
                    border-top: 1px solid rgba(255, 255, 255, 0.05);
                }

                .trust-verified-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    color: #ffb428;
                    font-size: 0.9rem;
                    font-weight: 600;
                }

                .trust-verify-link {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    color: #ffb428;
                    font-size: 0.9rem;
                    font-weight: 600;
                    text-decoration: none;
                    transition: all 0.3s ease;
                }

                .trust-verify-link:hover {
                    color: #fff;
                    gap: 12px;
                }

                /* ─── Technology Marquee ─── */
                .tech-marquee-section {
                    margin: 50px 0 40px;
                    text-align: center;
                }

                .tech-marquee-label {
                    font-size: 0.72rem;
                    font-weight: 700;
                    letter-spacing: 3px;
                    color: #5a5a5a;
                    text-transform: uppercase;
                    margin-bottom: 24px;
                    text-align: center;
                }

                .tech-marquee-wrapper {
                    position: relative;
                    overflow: hidden;
                    width: 100%;
                }

                .tech-marquee-fade {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    width: 100px;
                    z-index: 2;
                    pointer-events: none;
                }

                .tech-marquee-fade-left {
                    left: 0;
                    background: linear-gradient(to right, #0c001f, transparent);
                }

                .tech-marquee-fade-right {
                    right: 0;
                    background: linear-gradient(to left, #0c001f, transparent);
                }

                .tech-marquee-track {
                    display: flex;
                    gap: 48px;
                    animation: marqueeScroll 30s linear infinite;
                    width: max-content;
                }

                @keyframes marqueeScroll {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }

                .tech-marquee-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    white-space: nowrap;
                    flex-shrink: 0;
                }

                .tech-marquee-icon {
                    font-size: 1.6rem;
                    color: #5a5a5a;
                    display: flex;
                    transition: color 0.3s ease;
                }

                .tech-marquee-item:hover .tech-marquee-icon {
                    color: #a04ff4;
                }

                .tech-marquee-name {
                    font-size: 0.92rem;
                    color: #4a4a4a;
                    font-weight: 500;
                    transition: color 0.3s ease;
                }

                .tech-marquee-item:hover .tech-marquee-name {
                    color: #c0c0c0;
                }

                /* ─── Trust Badges Strip ─── */
                .trust-badges-strip {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    gap: 16px;
                    padding: 28px 0 0;
                    border-top: 1px solid rgba(255, 255, 255, 0.04);
                }

                .trust-strip-item {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: rgba(255, 255, 255, 0.03);
                    border: 1px solid rgba(255, 255, 255, 0.06);
                    padding: 10px 20px;
                    border-radius: 50px;
                    font-size: 0.88rem;
                    font-weight: 500;
                    color: #b0b0b0;
                    transition: all 0.3s ease;
                }

                .trust-strip-item:hover {
                    border-color: rgba(255, 180, 40, 0.3);
                    background: rgba(255, 180, 40, 0.05);
                    color: #d0d0d0;
                    transform: translateY(-2px);
                }

                .trust-strip-check {
                    color: #ffb428;
                    font-size: 0.8rem;
                    flex-shrink: 0;
                }

                /* ─── Responsive ─── */
                @media (max-width: 991px) {
                    .trust-certs-heading {
                        font-size: 2.5rem;
                    }
                }

                @media (max-width: 768px) {
                    .trust-certs-section {
                        padding: 80px 15px;
                    }
                    .trust-certs-heading {
                        font-size: 2.2rem;
                    }
                    .trust-premium-card {
                        padding: 32px 24px;
                    }
                    .tech-marquee-fade {
                        width: 40px;
                    }
                }

                @media (max-width: 576px) {
                    .trust-strip-item {
                        font-size: 0.8rem;
                        padding: 8px 14px;
                    }
                }
            `}</style>
        </>
    );
};

export default TrustCertifications;
